

exports.__esModule = true;
exports.$ContextualLoginModel = void 0;
var _squid = require("squid");
var $ContextualLoginModel = exports.$ContextualLoginModel = _squid.$Model.extend('$ContextualLoginModel', {
  init: function init() {
    this._super.init.apply(this);
    this.setProperties({
      key: _squid.$util.param('ctxId')
    });
  },
  api: new _squid.$Api({
    uri: '/api/contextualLogin/:key'
  })
});
angular.value("$ContextualLoginModel", $ContextualLoginModel);
_squid.$Model;
_squid.$Api;
_squid.$util;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/prox/index.js
// module id = ../node_modules/xo-models/src/prox/index.js
// module chunks = 0